import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetBatchUpdate';
import { Button, ConfirmDialog, IButtonProps } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';

type WorksheetBatchUpdateRefreshButtonProps = IButtonProps;

/**
 * Button that will refresh the worksheets loaded for the batch update page
 */
let WorksheetBatchUpdateRefreshButton: React.FC<WorksheetBatchUpdateRefreshButtonProps> = ({
  disabled,
  ...otherProps
}) => {
  const dispatch = useDispatch();

  const isSaving = useSelector((state) =>
    Object.values(state.worksheetBatchUpdate.worksheets).some((w) => w.status.synchronising)
  );
  const canRefresh = useSelector(
    (state) =>
      state.worksheetBatchUpdate.status.initialised &&
      state.worksheetBatchUpdate.status.queryReady &&
      !state.worksheetBatchUpdate.status.refreshingWorksheets &&
      !state.worksheetBatchUpdate.status.applyingUpdate &&
      !state.worksheetBatchUpdate.status.checking &&
      !state.worksheetBatchUpdate.status.configuring
  );
  const refreshing = useSelector((state) => state.worksheetBatchUpdate.status.refreshingWorksheets);

  return (
    <ConfirmDialog
      confirm={isSaving}
      confirmText="Refreshing data while changes are being saved may result in changes being lost. Are you sure you want to continue?"
    >
      <Button
        primary
        loading={refreshing}
        onClick={() => dispatch(actions.refreshWorksheets())}
        disabled={disabled || !canRefresh}
        {...otherProps}
      >
        Refresh
      </Button>
    </ConfirmDialog>
  );
};

WorksheetBatchUpdateRefreshButton = withInjectedProps(WorksheetBatchUpdateRefreshButton);

export default WorksheetBatchUpdateRefreshButton;
export { WorksheetBatchUpdateRefreshButton };
